module.exports = __webpack_public_path__ + "static/img/xh-avatar.0d9ab8f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/xh-avatar.png
// module id = 3u1G
// module chunks = 0